import styled from "styled-components";
import DownArrow from "web/assets/images/arrow_bottom_down_downward_navigation_icon.png";

const OrderDetailsWrapper = styled.div`
    min-height: 200px;
    .expand-collapse-class{
        display: flex;
        gap: 10px;
        
        .order-status {
            margin: 0;
            width: 101px;
        }

        h4{
            background: #005586;
            padding: 0px;
            width: 17px;
            border-radius: 50%;
            height: 16px;
            margin: 3px 0px 0px 11px;
            cursor: pointer;
            i {
                border: solid #ffff;
                border-width: 0 2px 2px 0;
                display: inline-block;
                padding: 2px;
                margin: 0px 0px 13px 6px;
                transform: rotate(-135deg);
                -webkit-transform: rotate(-135deg);
            }
        }  
        h5{
            background: #005586;
            padding: 0px;
            width: 16px;
            border-radius: 50%;
            height: 16px;
            margin: 3px 0px 0px 11px;
            cursor: pointer;
            i {
                border: solid #ffff;
                border-width: 0 2px 2px 0;
                display: inline-block;
                padding: 2px;
                margin: 0px 0px 13px 5px;
                transform: rotate(45deg);
                -webkit-transform: rotate(45deg);
            }
        }
        .action-items {
            display: flex;
            gap: 10px;
        }
    }    
    .create-order-button-styles{
        background: linear-gradient(90deg, #55C416 0%, #367910 100%);
        border: none;
        width: max-content;
        height: 26px;
        color: #fff;
        border-radius: 5px;
        padding: 3px 10px;
        font-size: 12px;
        margin: 0 5px;
    }
    .remark{
        word-wrap: break-word;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        max-width: 250px;
    }
    .order-details-wrapper{
        td{
            border: none;
        }
        h6{
            font-size: 13px;
            font-weight: bold;
        }
        p{
            font-size: 14px;
        }
        .print-tag-style{
            border: 1px solid #E5E5E5;
            padding: 3px 10px 4px;
            white-space:nowrap;
            border-radius: 3px;
            background: #fff;
        }
    }
    .adjustment-action-btn{
      margin: 0;
      background: #005586;
      color: #ffffff;
      padding: 5px 10px;
      border:none;
      border-radius:5px;
    }
    .withdraw-action-btn{
      background: none;
      padding: 0;
      border: none;
      border-radius: 5px;
      font-size: 12px;
      img{
        height: 18px;
        width: 18px;
      }
    }
    .bol-download-class{
      background: rgb(39, 145, 27);
      color: white;
      border: 0px;
      border-radius: 5px;
      padding: 5px 15px;
      height: 32px;
      margin: 5px;
      cursor: pointer;
      width: 150px;
      text-align: center;
    }
`;
const Heading = styled.div`
  display: flex;
  align-items: center;
  background-color: #87cdf1;
  padding: 11px 16px;
  min-height: 66px;
  flex-wrap: wrap;
  gap: 10px;
  h3 {
    font-size: 18px;
    color: #000;
    font-family: "latosemibold";
    flex-grow: 1;
  }
  .button-style-green {
    background: rgb(39, 145, 27);
    color: white;
    border: 0px;
    border-radius: 5px;
    padding: 5px 15px;
    height: 40px;
    margin: 5px;
    whiteSpace: nowrap;
    cursor: pointer;
  }
  .disabled-button {
    cursor: default;
    opacity: 0.5;
  }
  .order-request-action-wrapper{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
  }
  @media (max-width: 465px){
    gap: 0;
    > div{
      display: block;
      width: 100%;
    }
    .order-request-action-wrapper{
      display: block;
      width: 100%;
      div{
        justify-content: flex-start;
        label{
          min-width:100px;
        }
      }
      div[role=button]{
        width: auto;
        float: left;
      }
      select{
        margin: 10px 0 0 0;
        width: 100%;
      }
    }
  }
`;
const TableWrapper = styled.div`
  border-radius: 15px;
  border: solid 1px #87cdf1;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 9px 8px 0 rgb(0 0 0 / 16%);
  .table thead th {
    vertical-align: top;
    white-space: nowrap;
  }
  .table thead th,
  .table td,
  .table th {
    font-size: 14px;
  }
  .MuiPagination-ul {
    padding: 15px;
  }
  .MuiTab-textColorInherit.Mui-selected {
    opacity: 1;
    color: #0a1f30;
    font-family: "latobold" !important;
  }
  .MuiBox-root {
    padding: 0;
  }
  .MuiTab-root {
    opacity: 1;
    text-transform: capitalize;
    font-family: "latomedium";
    padding: 15px !important;
  }
  .MuiAppBar-colorPrimary {
    color: #7a7a7a;
    background-color: transparent;
    box-shadow: none;
    text-transform: capitalize;
  }
  .MuiTabs-indicator {
    border: solid 2px #2fb5f1;
    /* color: #0a1f30; */
  }
  .toggle-button-style {
    .MuiSwitch-root {
      width: 50px;
      height: 34px;
    }
    .MuiSwitch-thumb {
      width: 15px;
      height: 15px;
    }
  }

  .expand-collapse-class {
    display: flex;
    h4 {
      background: #005586;
      padding: 0px;
      width: 17px;
      border-radius: 50%;
      height: 16px;
      margin: 3px 0px 0px 11px;
      cursor: pointer;
      i {
        border: solid #ffff;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 2px;
        margin: 0px 0px 13px 6px;
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
      }
    }
    h5 {
      background: #005586;
      padding: 0px;
      width: 16px;
      border-radius: 50%;
      height: 16px;
      margin: 3px 0px 0px 11px;
      cursor: pointer;
      i {
        border: solid #ffff;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 2px;
        margin: 0px 0px 13px 5px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }
    }
  }
  .expand-collapse-class-inside {
    display: flex;
    h4 {
      /* background: #005586; */
      padding: 0px;
      width: 17px;
      border-radius: 50%;
      height: 16px;
      margin: 3px 0px 0px 11px;
      cursor: pointer;
      i {
        border: solid #000;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 2px;
        margin: 0px 0px 13px 6px;
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
      }
    }
    h5 {
      /* background: #005586; */
      padding: 0px;
      width: 16px;
      border-radius: 50%;
      height: 16px;
      margin: 3px 0px 0px 11px;
      cursor: pointer;
      i {
        border: solid #000;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 2px;
        margin: 0px 0px 13px 5px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }
    }
  }
`;
const DateWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  input {
    padding: 5px;
    border: solid 1px transparent !important;
    margin: 2px 0;
    font-size: 16px;
    padding: 6px 13px;
    border-radius: 5px;
    background-color: transparent;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    // min-width: 120px;
    max-width: 110px;
    max-height: 44px;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #656565;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #656565;
    }

    ::placeholder {
      color: #656565;
    }
  }
  label {
    padding: 9px;
    margin: 0;
    font-size: 16px;
  }
  @media (max-width: 465px){
    input{
        max-width: 100%;
    }
  }
`;
const SearchWrapper = styled.div`
  display: flex;
  position: relative;
  border-radius: 4.2px;
  overflow: auto;
  max-width: 200px;
  min-width: 165px;
  width: 100%;
  justify-content: end;
  input {
    background: #ffffff;
    border: none;
    padding: 4px 35px 4px 15px;
    width: 100%;
    border-radius: 3px;
    height: 42px;
    margin: 5px;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #00000087;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #00000087;
    }

    ::placeholder {
      color: #00000087;
    }
  }
  svg {
    position: absolute;
    right: 10px;
    top: 16px;
    color: #525e66;
  }
  @media (max-width: 465px){
    margin-left: 0px;
    max-width: 100%;
  }
`;
const SelectWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  width: 200px;
  .css-1wa3eu0-placeholder {
    color: #000;
  }
  .select__multi-value__label{
    font-size: 15px;
    color: #000;
  }
  .select__value-container{
    input{
      height: 38px;
    }
  }
  select,
  input {
    padding: 5px;
    border: solid 1px transparent !important;
    margin: 2px 0;
    font-size: 16px;
    padding: 10px 13px 10px 13px;
    border-radius: 5px;
    background-color: #e8e2e2;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    min-width: 180px;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #656565;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #656565;
    }

    ::placeholder {
      color: #656565;
    }
  }
  select {
    background-image: url(${DownArrow});
    background-repeat: no-repeat;
    background-position: calc(100% - 10px) 50%;
    padding: 10px 25px 10px 13px;
  }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 16px;
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }
  *::-webkit-scrollbar-thumb {
    border-color: none;
  }
  .chartModal {
    max-width: 172px;
    min-width: 0px;
  }
  .basic-multi-select {
    margin: 2px 0;
  }
  .select__value-container {
    input {
      padding: 7px 0;
      min-width: auto;
    }
  }
  .select__value-container {
    max-height: 78.38px;
    overflow: auto;
  }
  /* .react-select-2-input {
    padding: 7px 0;
  } */
  .select__control {
    border: none;
    background-color: #e8e2e2;
  }
  .react-select-2-input {
    padding: 5px 0;
  }
  .searchContainer input { 
    font-size: 14px !important;
  }
  button { 
    font-size: 14px !important;
    text-align: left;
    padding-left: 15px;
    height: 46px !important;
  }
  .checkbox-container {
    padding: 0px 5px;
    margin-bottom: 15px !important;
  }
`;
const AdjustmentHeader = styled.div`
  .red-outline{
    border: 2px solid #b11212;
    border-radius: 5px;
  }
  .modal-body {
    padding: 0px !important;
  }
`;
export {
    OrderDetailsWrapper,
    Heading,
    TableWrapper,
    DateWrapper,
    SelectWrapper,
    SearchWrapper,
    AdjustmentHeader
};
